import { Project, ProjectMap, FilteredProjectMap, FOLD_STATE } from '../Components/ProjectTypes';
import ProjectComponentWrapper from "../Components/Project";
import { ProjectListState } from '../SiteState/SiteStateTypes';

function ProjectListLayout({ projectMap, projectListState }: { projectMap: ProjectMap, projectListState?: ProjectListState }) {
    if (!projectListState) {
        return null;
    }

    const filteredProjects = projectListState.filteredProjects;

    return (
        <div style={{ width: "100%", height: "100%" }} className="projectListLayout">
            {Object.keys(projectMap).map((projectKey) => {
                const projectIsEnabled = Object.keys(filteredProjects).includes(projectKey);

                return <EnabledDisabledProject project={projectMap[projectKey]} isEnabled={projectIsEnabled} />;
            })}
        </div>
    );
}

function EnabledDisabledProject({ project, isEnabled }: { project: Project, isEnabled: boolean }) {

    const enabledDisabledClass = isEnabled ? "enabledProject" : "disabledProject";

    return (
        <div style={{ width: "100%", height: "100%" }} className={`enabledDisabledProject ${enabledDisabledClass}`}>
            <ProjectComponentWrapper foldState={FOLD_STATE.BASIC_INFO} project={project} />
        </div>
    );
}

export default ProjectListLayout;